import { connect } from 'react-redux';
import { playlistActions, RootState, Dispatch } from '../../api';
import AddTrack, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/Modals/Playlist/AddTrack';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  ({ playlists }) => ({
    queue: playlists.queue,
  }),
  (dispatch: Dispatch) => ({
    addTrack: (playlistId, trackId) => {
      dispatch(playlistActions.addTrack(playlistId, trackId));
    },
  }),
)(AddTrack);
